import * as types from "../constants/alertConstants";
import { LOGOUT } from "../constants/authConstants";

const initialState = {
    alert: {},
    alertError: null,
    allAlerts: [],
    allArchAlerts: [],
    latestAlert: [],
    incidentsRate: null,
    highestZone: {},
    totalAlertsPerMonth: 0,
    alertsWeekly: [],

};

const alertReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case LOGOUT:
            return {
                ...state,
                alert: {},
                alertError: null,
                allAlerts: [],
                allArchAlerts: [],
                latestAlert: [],
                incidentsRate: null,
                highestZone: {},
                totalAlertsPerMonth: 0,
                alertsWeekly: [],
            };

        case types.GET_ALERT_SUCCESS:
            return { ...state, alert: payload, alertError: null };

        case types.GET_ALERT_FAIL:
            return { ...state, alertError: payload };

        case types.GET_ALERT_ALL_SUCCESS:
            return {
                ...state,
                allAlerts: payload || [],
                alertError: null,
            };

        case types.GET_ALERT_ALL_FAIL:
            return { ...state, alertError: payload };

        case types.GET_TOTAL_ALERTS_PER_MONTH_SUCCESS:
            return {
                ...state,
                totalAlertsPerMonth: payload || null,
                alertError: null,
            };

        case types.GET_TOTAL_ALERTS_PER_MONTH_FAIL:
            return { ...state, alertError: payload };

        case types.GET_LATEST_ALERT_SUCCESS:
            return {
                ...state,
                latestAlert: payload || null,
                alertError: null,
            };

        case types.GET_LATEST_ALERT_FAIL:
            return { ...state, alertError: payload };

        case types.GET_INCIDENTS_RATE_SUCCESS:
            return {
                ...state,
                incidentsRate: payload,
                alertError: null
            };

        case types.GET_INCIDENTS_RATE_FAIL:
            return { ...state, alertError: payload };

        case types.GET_HIGHEST_ZONE_SUCCESS:
            return {
                ...state,
                highestZone: payload,
                alertError: null
            };

        case types.GET_HIGHEST_ZONE_FAIL:
            return { ...state, alertError: payload };

        case types.GET_ALERT_WEEKLY_SUCCESS:
            return {
                ...state,
                alertsWeekly: payload,
                alertError: null
            };

        case types.GET_ALERT_WEEKLY_FAIL:
            return { ...state, alertError: payload };

        case types.GET_ARCH_ALERT_ALL_SUCCESS:
            return {
                ...state,
                allArchAlerts: payload || [],
                alertError: null,
            };

        case types.GET_ARCH_ALERT_ALL_FAIL:
            return { ...state, alertError: payload };
            
        default:
            return state;
    }
};

export default alertReducer;
